<template>
  <at-sidebar-user-popover :user="{ phone: user?.me?.preferred_username, name: user?.me?.name }">
    <template #user-popover-header>
      <div class="flex items-center justify-between">
        <span class="font-medium">
          {{ $t('widgets.profileSettings.title') }}
        </span>

        <button class="flex items-center gap-1" type="button" @click="handleLogout">
          <span class="text-[#9CA3AF] text-sm">
            {{ $t('widgets.profileSettings.logout') }}
          </span>
          <span class="text-[#9CA3AF] w-4 h-4">
            <arrow-right-icon />
          </span>
        </button>
      </div>
    </template>
    <template #user-popover-content>
      <div class="-mb-4">
        <div>
          {{ $t('widgets.profileSettings.lang') }}
        </div>
        <div>
          <at-radio-group
            class="mt-3"
            no-border
            :items="[
              { value: 'ru', title: $t('widgets.profileSettings.ru') },
              { value: 'uz', title: $t('widgets.profileSettings.uz') },
            ]"
            :model-value="lang"
            @update:model-value="changeLang($event)"
          />
        </div>
      </div>
    </template>
    <template #user-popover-footer>
      <div>
        <at-toggle
          :label="$t('widgets.profileSettings.toggleLabel')"
          label-position="right"
          :model-value="theme === 'dark'"
          @update:model-value="setTheme($event ? 'dark' : 'light')"
        />
      </div>
    </template>
  </at-sidebar-user-popover>
</template>

<script setup>
  import { ArrowRightIcon } from '@heroicons/vue/solid';
  import { AtToggle, AtSidebarUserPopover, AtRadioGroup } from '@packages/aliftech-ui';
  import { useLang, useTheme } from '@/to-fsd/shared/hooks';
  import { ROUTE_NAMES as MAIN_ROUTES } from '@/to-fsd/shared/constants';
  import { reactive } from 'vue';
  import { useKeycloakLogoutMutation } from '@/to-fsd/shared/lib/keycloak';
  import { useRouter } from 'vue-router';
  import { useUserStore } from '@/to-fsd/shared/store/user';
  import { useNasiyaGlobalStore } from '@/to-fsd/shared/store/nasiya-global';
  import { useMainStore } from '@/to-fsd/shared/store/main';

  const mutations = reactive({
    logout: useKeycloakLogoutMutation(),
  });

  const user = useUserStore();
  const store = useNasiyaGlobalStore();
  const mainStore = useMainStore();

  const { theme, setTheme } = useTheme();
  const { lang, changeLang } = useLang();

  const router = useRouter();

  const handleLogout = async () => {
    try {
      await mutations.logout.mutateAsync();
    } finally {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('access_token_expire');
      localStorage.removeItem('refresh_token_expire');
      router.push({ name: MAIN_ROUTES.login }).then(() => {
        user.$reset();
        mainStore.$reset();
        store.$reset();
      });
    }
  };
</script>
